export class HttpError extends Error {
  constructor(status, statusText, data, url) {
    super(`${status} ${statusText}`);
    this.status = status;
    this.statusText = statusText;
    this.data = data;
    this.url = url;
  }
}

export function isAborted(error) {
  return error?.name === 'AbortError';
}
